export default "__VITE_ASSET__NPBBB7Mj__"